// Очистка runtime-кэшей PWA.
// Вызывается при logout, чтобы закэшированные ответы API (например данные
// расписаний) одного пользователя не оставались доступны другому на общем
// устройстве. Precache статики не трогаем — он не содержит данных пользователя.

const RUNTIME_CACHES = ["api-read"]

export const clearRuntimeCaches = async () => {
  if (typeof caches === "undefined") return

  try {
    await Promise.all(RUNTIME_CACHES.map((name) => caches.delete(name)))
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[pwa] failed to clear runtime caches", err)
  }
}
